define('commons/ui-element-introduction',['jquery', 'introjs'], function($, introJs) {

    /**
     * This module runs an introJs introduction if necessary, i.e. if the user has never seen the introduction before.
     * @param elementKeys The keys array for the new element(s) to introduce. Note that a key can be related with a group of elements.
     *        Use UIElementIntroduction#ELEMENT_KEYS.get('xxx') to avoid any key overriding.
     */
    var UIElementIntroduction = function( elementKeys ) {
        this.elementKeys = Array.isArray(elementKeys) ? elementKeys : [elementKeys];
        // Steps used when there's some new ui elements on the page
        this.newUiElementSteps =  [ {element: '#global-help',intro: 'There are new features available, click to discover them.', position:'left'}];
    };
    
    UIElementIntroduction.ELEMENT_KEYS = (function() {
        var privateConstants = {
            'ACCORDION_FILTER' : 'accordionFilter'
        };

        return {
            get: function(name) {
                return privateConstants[name];
            }
        };
    })();
    
    /**
     * Checks first if the user has already seen the introJs for this element, and if not runs the introJs and mark the element as seen.
     */
    UIElementIntroduction.prototype.runIfNeverSeen = function(){
        var here = this;
        // First, we want to know whether or not the user knows what's / where's the element
        $.ajax({
            type: 'GET',
            context : here,
            url: '/userPrefs/json/has-seen-intro',
            data : 'keys=' + this.elementKeys.join(';'),
            success: function onRetrieveHasSeenHelpButtonSuccess(data) {
                var hasSeenElementIntro = data.hasSeenAllIntro;

                // If not, show him 
                if(!hasSeenElementIntro){
                    var eltIntro = introJs();
                    eltIntro.setOptions({
                        steps : here.newUiElementSteps,
                        tooltipClass : 'custom-global-help-tooltip'
                    });
                    eltIntro.start();
                    
                    // Mark the element as seen by the user
                    $.ajax({
                        type: 'POST',
                        context : here,
                        url: '/userPrefs/edit/has-seen-intro',
                        contentType: 'application/json; charset=UTF-8',
                        data: JSON.stringify( this.elementKeys )
                    });
                }
            }
        });
    };
    
    return UIElementIntroduction;
});
